import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { breakpoints } from "../lib/utils"

export default class MobileQuestionModalController extends Controller {
  static values = {
    questionText: String,
  }

  static targets = ["input", "questionText"]

  declare questionTextValue: string

  declare readonly inputTarget: HTMLTextAreaElement
  declare readonly questionTextTarget: HTMLElement

  mainController: MobileQuestionModalController

  open(event: Event) {
    if (window.innerWidth >= breakpoints.md) {
      return
    }

    event.preventDefault()

    const modalEl = document.getElementById("mobile-question-modal")
    const modalController = window.Stimulus.getControllerForElementAndIdentifier(
      modalEl,
      "mobile-question-modal",
    ) as MobileQuestionModalController

    modalController.mainController = this
    modalController.questionTextTarget.textContent = this.questionTextValue
    modalController.inputTarget.value = (this.element as HTMLTextAreaElement).value
    if ((this.element as HTMLTextAreaElement).maxLength > 0) {
      modalController.inputTarget.maxLength = (this.element as HTMLTextAreaElement).maxLength
    }
    modalController.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))

    Modal.getOrCreateInstance(modalEl).show()
  }

  focusModalTextarea() {
    this.inputTarget.focus()
  }

  save(event: Event) {
    ;(this.mainController.element as HTMLTextAreaElement).value = this.inputTarget.value
    this.mainController.element.dispatchEvent(new Event("input", { bubbles: true }))
    Modal.getOrCreateInstance(this.element).hide()
    setTimeout(() => {
      this.mainController.dispatch("commit")
    })
  }
}
